import "./style.scss";
import "swiper/css";
import "swiper/css/navigation";
import { FC, useEffect, useRef, useState } from "react";
import { IProgram } from "@/src/types/IUniversityPrograms";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import type { Swiper as SwiperClass } from "swiper/types";
import { Arrow } from "@/src/svg/Arrow";
import { Link } from "react-router-dom";
import univSchoolPrograms from "@/src/assets/HomePage/UniversityPrograms/univ-school-programs.png";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
interface IUniversityProgramsSlider {
  programs: IProgram[];
  path: string;
}

const UniversityProgramsSliderDesk: FC<IUniversityProgramsSlider> = ({ programs, path }) => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);
  const [swiperReady, setSwiperReady] = useState(false);

  useEffect(() => {
    setSwiperReady(false);
    const timer = setTimeout(() => {
      setSwiperReady(true);
    }, 0);
    return () => clearTimeout(timer);
  }, [programs]);

  return (
    <div className="university-programs-slider">
      <div className="university-programs-slider-header">
        <img src={univSchoolPrograms} alt="Img" />
        <p>Программы</p>
      </div>
      <div className="university-programs-slider-body">
        {swiperReady && (
          <Swiper
            direction="vertical"
            modules={[Navigation]}
            spaceBetween={8}
            slidesPerView={Math.min(programs.length, 6)}
            watchOverflow={false}
            navigation={{
              prevEl: prevRef.current!,
              nextEl: nextRef.current!,
            }}
            onBeforeInit={(swiper: SwiperClass) => {
              const navigation = swiper.params.navigation;
              if (navigation && typeof navigation === "object") {
                navigation.prevEl = prevRef.current;
                navigation.nextEl = nextRef.current;
              }
            }}
          >
            {programs.map((program, index) => (
              <SwiperSlide key={index}>
                <Link to={program.path}>
                  <p>{program.name}</p>
                  <span>{program.subName}</span>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
      <div className="university-programs-slider-footer">
        <ReadMoreBtn text="Смотреть все →" link={`programs/${path}`} />
        <div className="university-programs-slider-buttons">
          <button className="university-programs-slider-button prev" ref={prevRef}>
            <Arrow />
          </button>
          <button className="university-programs-slider-button next" ref={nextRef}>
            <Arrow />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UniversityProgramsSliderDesk;
